import { fetchData } from '../utils';

/**
 * API Services
 *
 * @export
 * @class BackendService
 */
class BackendService {
  constructor(config) {
    // INFO: config de la URL de la API, la opción por la variable window es en caso
    // de que Kubernetes setee las vars despues del build que ya usa el process.env
    this.apiURL = config.API_URL;
    this.passURL = config.PASS_URL;

    this.getData = this.getData.bind(this);
    this.getUserToken = this.getUserToken.bind(this);
    this.getSupportNumber = this.getSupportNumber.bind(this);
    this.getSupportData = this.getSupportData.bind(this);
    this.getLoginAndLogoutData = this.getLoginAndLogoutData.bind(this);
    this.logout = this.logout.bind(this);
  }

  /**
   * Service call
   *
   * @returns {Promise} Respuesta del endpoint
   * @memberof BackendService
   */
  getData() {
    const options = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };
    let url = '/system/ping';

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }

  /**
   * Service call
   *
   * @returns {Promise} Respuesta del endpoint
   * @memberof BackendService
   */
  getUserToken(cp) {
    let d = new Date();
    let n = d.getTime();

    const options = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };

    let url = `/auth/${cp}/status.json?rand=${n}`;

    if (this.passURL) {
      url = `${this.passURL + url}`;
    }

    return fetchData(url, options);
  }

  getSupportNumber(cp, status) {
    const options = {
      credentials: 'omit',
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(status)
    }

    let url = `/data/${cp}/save`;

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }

  getSupportData(cp, supportNumber, key) {
    const options = {
      credentials: 'omit',
      method: 'get',
      headers: {
        Accept: 'application/json',
        Authorization: key
      }
    };
    let url = `/data/${cp}/${supportNumber}`;

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }

  logout(logoutUrl) {
    const logoutOptions = {
      credentials: 'include',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };

    return fetchData(logoutUrl, logoutOptions)
  }

  getLoginAndLogoutData(cp) {
    const options = {
      credentials: 'omit',
      method: 'get',
      headers: {
        Accept: 'application/json'
      }
    };
    let url = `/user/loginAndLogoutData/${cp}`;

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }

  getSupportDataFromEmail(cp, email, key) {
    const options = {
      credentials: 'omit',
      method: 'get',
      headers: {
        Accept: 'application/json',
        Authorization: key
      }
    };
    let url = `/data/${cp}/useremail?email=${email}`;

    if (this.apiURL) {
      url = `${this.apiURL + url}`;
    }

    return fetchData(url, options);
  }
}

export default new BackendService(window.AppENV || {});
